module.exports = __webpack_public_path__ + "static/media/flower_hero_mobile.40765f96.jpg";